import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  MatTreeFlatDataSource,
  MatTreeFlattener
} from '@angular/material/tree';
import { Router } from '@angular/router';
import { Utils } from '@app/shared/helpers/utils';
import {
  convertDateToMaskTimezone,
  validarAdicaoRaiz,
  verificarRotasDeAcessoRaiz
} from '@app/shared/utils';
import { CustomValidators, TokenService } from 'viggo-sistemas-core-web';

export interface NodeConfirmDialog {
  descricao: string;
  msg_erro: string;
  mensagem: string;
  bolder?: boolean;
  link?: string;
  url_validate?: any;
  mensagens?: NodeConfirmDialog[];
}

export interface FlatNodeConfirmDialog {
  expandable: boolean;
  descricao: string;
  msg_erro: string;
  mensagem: string;
  bolder?: boolean;
  link?: string;
  url_validate?: any;
  level: number;
}
export interface ConfirmDialogData {
  title: string;
  bodyMessage: string;
  labelCloseButton?: string;
  labelConfirmButton?: string;
  colorCloseButton?: string;
  colorConfirmButton?: string;
  optionCheckBox?: boolean;
  labelOptionCheckBox?: string;
  existsObs?: boolean;
  obsValue?: string;
  singleBtn?: boolean;
  breakline?: boolean;
  icon_color?: string;
  maxwidth?: string;
  icon?: string;
  options_select_label?: string;
  options?: [
    {
      label: string;
      value: any;
      disabled: boolean;
    }
  ];
  options_select?: [
    {
      label: string;
      value: any;
    }
  ];
  option_initial_select?: any;
  useCheckbox?: boolean;
  multipleMsgs?: boolean;
  submsgs?: any[];
  subBodyMessage?: string;
  showCloseBtn?: boolean; // exibe o botao de fechar dialog
  useAccessRouterSubMsg?: boolean; // CASO VENHA TRUE O SUBMSGS VAI CONTER UM LINK DE ACESSO
  subMsgsTree?: NodeConfirmDialog[];
  showMultipleMsg?: boolean;
  contentHeightSubmsgs?: string;
  useDateField?: boolean;
  usePasswordField?: boolean;
}

@Component({
  selector: 'app-name',
  templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent implements OnInit {
  public keywordFormDateRange = new UntypedFormControl();
  public keywordFormDateRangeStart = new UntypedFormControl();
  public keywordFormDateRangeEnd = new UntypedFormControl();
  public passwordControl = new UntypedFormControl();
  public observacaoFormControl: UntypedFormControl;
  public estoqueFormControl: UntypedFormControl;
  maxwidth = 'max-width: auto';
  selectedValue: string;
  selectedValueOption: string;
  checkboxValues = [];

  private _transformer = (node: NodeConfirmDialog, level: number) => {
    return {
      expandable: !!node.mensagens && node.mensagens.length > 0,
      descricao: node.descricao,
      msg_erro: node.msg_erro,
      mensagem: node.mensagem,
      url_validate: node.url_validate,
      link: node.link,
      bolder: node.bolder,
      level: level
    };
  };
  treeControl = new FlatTreeControl<FlatNodeConfirmDialog>(
    node => node.level,
    node => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.mensagens
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  // eslint-disable-next-line no-useless-constructor
  constructor(
    protected router: Router,
    protected tokenService: TokenService,
    public matDialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    if (data.showMultipleMsg) {
      this.dataSource.data = data.subMsgsTree;
    }
    if(data.option_initial_select){
      this.selectedValueOption = data.option_initial_select;
    }
  }

  /**
   * @lifeCycle
   */
  public ngOnInit(): void {
    this.observacaoFormControl = new UntypedFormControl(
      this.data.obsValue != null ? this.data.obsValue : '',
      [Validators.maxLength(500), Validators.required]
    );
    this.observacaoFormControl.markAsDirty();

    this.estoqueFormControl = new UntypedFormControl(false);
    this.estoqueFormControl.markAsDirty();

    this.passwordControl = new UntypedFormControl('', [
      Validators.maxLength(64),
      Validators.required,
      CustomValidators.isEmptyValue()
    ]);
    this.passwordControl.markAsDirty();

    this.keywordFormDateRange.setValue([new Date(), new Date()]);
    this.keywordFormDateRangeStart.setValue(new Date());
    this.keywordFormDateRangeEnd.setValue(new Date());
    this.keywordFormDateRange.valueChanges.subscribe(value => {
      if (value) {
        if (value[0]) this.keywordFormDateRangeStart.setValue(value[0]);
        if (value[1]) {
          this.keywordFormDateRangeEnd.setValue(value[1]);
        }
      }
    });
  }

  /**
   * Salva as informacoes inseridas repassando para o component que chamou o dialog
   */
  public async confirmar(): Promise<void> {
    if (
      !this.data.existsObs &&
      !this.data.options &&
      !this.data.options_select &&
      !this.data.useDateField &&
      !this.data.usePasswordField &&
      !this.data.optionCheckBox
    )
      this.matDialogRef.close(true);
    else {
      const response = { confirm: true } as any;
      if (this.data.options && !this.data.options_select) {
        response.option = this.data.useCheckbox
          ? this.checkboxValues
          : this.selectedValue;
      }

      if (!this.data.options && this.data.options_select) {
        response.option = this.selectedValueOption;
      }

      if (this.data.options && this.data.options_select) {
        response.option = this.data.useCheckbox
          ? this.checkboxValues
          : this.selectedValue;
        response.optionSelect = this.selectedValueOption;
      }

      if (this.data.existsObs) {
        if (this.observacaoFormControl.invalid) {
          this.observacaoFormControl.updateValueAndValidity();
          return;
        } else {
          const observacao = this.observacaoFormControl.value;
          response.observacao = observacao;
        }
      }

      if (this.data.optionCheckBox) {
        if (this.estoqueFormControl.invalid) {
          this.estoqueFormControl.updateValueAndValidity();
          return;
        } else {
          const estoque = this.estoqueFormControl.value;
          response.estoque = estoque;
        }
      }

      if (this.data.useDateField) {
        if (this.keywordFormDateRange.invalid) {
          return;
        } else {
          response.date_de = convertDateToMaskTimezone(
            this.keywordFormDateRangeStart.value
          );
          response.date_ate = convertDateToMaskTimezone(
            this.keywordFormDateRangeEnd.value
          );
        }
      }

      if (this.data.usePasswordField) {
        if (this.passwordControl.invalid) {
          this.passwordControl.updateValueAndValidity();
          return;
        } else {
          const senha = await Utils.encryptPassword(this.passwordControl.value);
          response.senha = senha;
        }
      }

      this.matDialogRef.close(response);
    }
  }

  get disabledConfirmBtn() {
    const {
      data,
      observacaoFormControl,
      passwordControl,
      keywordFormDateRange,
      selectedValueOption,
      selectedValue
    } = this;
    const {
      existsObs,
      options,
      options_select,
      useCheckbox,
      useDateField,
      usePasswordField
    } = data;
    var invalid = [];
    if (existsObs) invalid.push(observacaoFormControl.invalid);
    if (options && !options_select && !useCheckbox)
      invalid.push(!selectedValue);
    if (!options && options_select) invalid.push(!selectedValueOption);
    if (options && options_select)
      invalid.push(!selectedValueOption || !selectedValue);
    if (usePasswordField) invalid.push(passwordControl.invalid);
    if (useDateField) invalid.push(keywordFormDateRange.invalid);
    return invalid.some(it => it);
  }

  /**
   * Preenche as seleções de checkbox para serem emitidas para o componente pai
   * @param value
   */
  selectCheckBox(value) {
    if (this.checkboxValues.length !== 0) {
      const index = this.checkboxValues.findIndex(
        select_key => Object.keys(select_key)[0] === Object.keys(value)[0]
      );
      if (index >= 0) {
        this.checkboxValues.splice(index, 1);
      } else this.checkboxValues.push(value);
    } else this.checkboxValues.push(value);
  }

  /**
   * Envia o usuário para uma rota especifica do projeto
   * @param route
   */
  sendTo(route) {
    const url = this.router.serializeUrl(this.router.createUrlTree([route]));
    window.open(url, '_blank');
  }

  hasChild = (_: number, node: FlatNodeConfirmDialog) => node.expandable;

  verificarDisponibilidade(url: { method: string; url: string }) {
    const routesAcess = verificarRotasDeAcessoRaiz(
      this.tokenService.getRoutes(),
      url.url
    );
    return validarAdicaoRaiz(routesAcess, url.method, '', url.url);
  }
}
